<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {
    this.$quanju("$yonghux", this.$qu("yonghux"));

    // this.$swoole();
  },
};
</script>

<style lang="less">
@import "./styles/public.css";
@import "./styles/reset.css";

.el-message {
  min-width: 350px !important;
}

// @import "./plugins/icon.css";
// @import "./plugins/icon_1.css";
// @import "./plugins/zhiwi.css";
.el-tabs__nav {
  margin-left: 0;
}
.el-input__inner {
  border: auto !important;
}
.el-form-item__content {
  margin-left: auto;
}

.el-table--border th.gutter:last-of-type {
  display: block !important;
  width: 17px !important;
}
.cur_pointer {
  cursor: pointer;
}
</style>
<style lang="less">
@import "./styles/media.less";
</style>
